module.exports = {
  feedback: 'Feedback / Rate the App',
  menu: 'Menu',
  quiz: 'Quiz battle',
  statistics: 'Statistics',
  tests: 'Tests',
  home: 'Home',
  notification_settings: 'Notifications',
  profile: 'Profile',
  vouchers: 'Voucher codes',
  features: 'Functions',
  information: 'Information',
  logout: 'Log out',
  learning: 'Learn',
  webinars: 'Webinars',
  training: 'Training',
  mediacenter: 'Media library',
  courses: 'Courses',
  powerlearning: 'Powerlearning',
  appointments: 'Appointments',
  profile_settings: 'Profile settings',
  more: 'More',
  todolists: 'Todos',
  language: 'Language',
  communities: 'Communities',
  mobile_navigation: 'Mobile navigation',
}
